var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoRecorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 7.94411C18.3307 7.43926 18.3307 7.18684 18.2309 7.06995C18.1443 6.96853 18.0143 6.91471 17.8814 6.92518C17.7281 6.93724 17.5496 7.11573 17.1927 7.47271L14.1641 10.5013L17.1927 13.5299C17.5496 13.8869 17.7281 14.0654 17.8814 14.0774C18.0143 14.0879 18.1443 14.0341 18.2309 13.9326C18.3307 13.8158 18.3307 13.5633 18.3307 13.0585V7.94411Z",
    stroke: "#344054",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 8.66797C1.66406 7.26784 1.66406 6.56777 1.93655 6.03299C2.17623 5.56259 2.55868 5.18014 3.02909 4.94045C3.56387 4.66797 4.26393 4.66797 5.66406 4.66797H10.1641C11.5642 4.66797 12.2643 4.66797 12.799 4.94045C13.2694 5.18014 13.6519 5.56259 13.8916 6.03299C14.1641 6.56777 14.1641 7.26784 14.1641 8.66797V12.3346C14.1641 13.7348 14.1641 14.4348 13.8916 14.9696C13.6519 15.44 13.2694 15.8225 12.799 16.0622C12.2643 16.3346 11.5642 16.3346 10.1641 16.3346H5.66406C4.26393 16.3346 3.56387 16.3346 3.02909 16.0622C2.55868 15.8225 2.17623 15.44 1.93655 14.9696C1.66406 14.4348 1.66406 13.7348 1.66406 12.3346V8.66797Z",
    stroke: "#344054",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.26e393dcf897f822c81f1cc31e84016b.svg";
export { ForwardRef as ReactComponent };